<template>
    <div>
        <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="用户ID">
                <el-input v-model="form.user_id"></el-input>
            </el-form-item>
            <el-form-item label="来源">
                <el-select v-model="form.source" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台订单id">
                <el-input v-model="form.provider_id"></el-input>
            </el-form-item>
            <el-form-item label="用户佣金(元)">
                <el-input v-model="form.commission"></el-input>
            </el-form-item>
            <el-form-item label="平台佣金(元)">
                <el-input v-model="form.base_commission"></el-input>
            </el-form-item>
            <el-form-item
                label="投保时间"
            >
                <el-date-picker
                    v-model="form.insure_time"
                    type="datetime"
                    placeholder="选择日期时间"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="冻结天数(天)">
                <el-input v-model="form.freeze"></el-input>
                <span style="color: red;">ps: 佣金结算时间 = 投保时间 + 冻结天数</span>
            </el-form-item>
            <el-form-item label="保费(元)">
                <el-input v-model="form.premium"></el-input>
            </el-form-item>
            <el-form-item label="商品名称">
                <el-input v-model="form.ware_name"></el-input>
            </el-form-item>
            <div>保单</div>
            <div class="box" v-for="(item, index) in form.policy_data" :key="index">
                <el-button type="danger"
                           icon="el-icon-delete"
                           size="mini"
                           v-if="index !== 0"
                           @click="remove(index)"
                           circle></el-button>
                <span v-else class="black-span"></span>
                <div class="policy-box" >

                    <el-form-item label="保单号" label-width="100px">
                        <el-input v-model="item.policy_no" class="policy-box-input"></el-input>
                    </el-form-item>
                    <el-form-item label="被保人姓名" label-width="100px">
                        <el-input v-model="item.insurant_name" class="policy-box-input"></el-input>
                    </el-form-item>
                    <el-form-item label="投保人姓名" label-width="100px">
                        <el-input v-model="item.applicant_name" class="policy-box-input"></el-input>
                    </el-form-item>
                    <el-form-item label="缴费期限类型" label-width="100px">
                        <el-select v-model="item.payment_period_type" placeholder="请选择" class="policy-box-input">
                            <el-option
                                v-for="item in option2"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="缴费年限" label-width="100px">
                        <el-input v-model="item.payment_period" class="policy-box-input"></el-input>
                        <span style="color: red;">&emsp;缴费期限类型为趸缴，不需要填写</span>
                    </el-form-item>
                    <el-form-item label="保障期限类型" label-width="100px">
                        <el-select v-model="item.coverage_period_type" placeholder="请选择" class="policy-box-input">
                            <el-option
                                v-for="item in option1"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="保障年限" label-width="100px">
                        <el-input v-model="item.coverage_period" class="policy-box-input"></el-input>
                        <span style="color: red;">&emsp;保障年限类型为终身，不需要填写</span>
                    </el-form-item>
                    <el-form-item label="保费(元)" label-width="100px">
                        <el-input v-model="item.premium" class="policy-box-input"></el-input>
                    </el-form-item>
                </div>
            </div>
            
            <el-button type="primary"
                       icon="el-icon-circle-plus-outline"
                       size="mini"
                       @click="addRow"
                       plain>添加保单</el-button>
        </el-form>
        <el-button
            class="submit-btn"
            type="primary"
            size="small"
            @click="add"
        >添加</el-button>
    </div>
</template>
<script>
import request from "@/api/request";
import { cloneDeep } from 'lodash'
import { format } from "date-fns"

export default {
    data(){
        return {
            form: {
                user_id: '',                // 用户id
                source: '',                 // 来源
                provider_id: '',            // 平台订单id
                freeze: '',                 // 冻结天数
                commission: '',             // 用户佣金
                base_commission: '',        // 平台佣金
                insure_time: '',            // 投保时间
                premium: '',                // 保费
                ware_name: '',              // 商品名称
                policy_data: [
                    {
                        policy_no: '',          // 保单号
                        insurant_name: '',      // 被保人姓名
                        applicant_name: '',     // 投保人姓名
                        payment_period: '',     // 缴费年限
                        coverage_period: '',    // 保障年限
                        premium: '',            // 保费
                        coverage_period_type: '', //保障期限类型
                        payment_period_type: ''//缴费期限类型
                    }
                ],
            },
            options: [],
            option1: [],//保障期限类型
            option2: []//缴费期限类型
        }
    },
    mounted() {
        //来源
        request.tools
            .post('defined_get', {prefix: 'PO_SOURCE_'})
            .then(resp => {
                console.log(resp)
                this.options = resp.data
            })
        //保障期限类型
        request.tools
            .post('defined_get', {prefix: 'POLICY_COVERAGE_PERIOD_TYPE_'})
            .then(resp => {
                console.log(resp)
                this.option1 = this.optionFormat(resp.data, 'POLICY_COVERAGE_PERIOD_TYPE_')
            })
        //缴费期限类型
        request.tools
            .post('defined_get', {prefix: 'POLICY_PAYMENT_PERIOD_TYPE_'})
            .then(resp => {
                console.log(resp)
                this.option2 = this.optionFormat(resp.data, 'POLICY_PAYMENT_PERIOD_TYPE_')
            })
    },
    methods:{
        add(){
            this.$confirm(`确定添加保单吗`)
                .then(() => {
                    this.submit()
                })
        },
        submit(){
            const formData  = cloneDeep(this.form)
            
            formData.user_id = Number(formData.user_id)
            formData.freeze = Number(formData.freeze)
            formData.commission = Number(formData.commission) * 100
            formData.base_commission = Number(formData.base_commission) * 100
            formData.premium = Number(formData.premium) * 100
            formData.insure_time = format(formData.insure_time, "yyyy-MM-dd HH:mm:ss")

            
            formData.policy_data.map(item => {
                item.premium = Number(item.premium) * 100
                //payment_period: '',     // 缴费年限
                //coverage_period: '',    // 保障年限
                for ( var key in item ){
                    if ( item[key] === '' && (key === 'payment_period' || key === 'coverage_period') ){
                        delete item[key]
                    }
                }
                
                if(item.payment_period) {
                    item.payment_period = Number(item.payment_period)
                }
                if(item.coverage_period ) {
                    item.coverage_period = Number(item.coverage_period)
                }
            })


            console.log(formData)
            request.policy
                .post('manual_create', formData)
                .then(() => {
                    this.$message.success('添加成功')
                })
        },
        addRow(){
            const policy_data = {
                policy_no: '',          
                insurant_name: '',      
                applicant_name: '',     
                payment_period: '',     
                coverage_period: '',    
                premium: '',
                coverage_period_type: '', 
                payment_period_type: ''
            }
            this.form.policy_data.push(policy_data)
        },
        remove(index){
            this.form.policy_data.splice(index, 1)
        },
        optionFormat(option, type){
            const o = []
            if( type === 'POLICY_COVERAGE_PERIOD_TYPE_'){
                //保障期限类型：
                option.forEach(item => {
                    let a = {
                        value: item === 'all' ? '终身': item === 'age' ? '至xx岁' : '保xx年',
                        key: item
                    }
                    o.push(a)
                })
            } else{
                //缴费期限类型
                option.forEach(item => {
                    let a = {
                        value: item === 'all' ? '趸缴': item === 'age' ? '至xx岁' : '缴xx年',
                        key: item
                        
                    }
                    o.push(a)
                })
            }
            
            
            
            return o
        }
    }
}
</script>
<style scoped>
>>> .el-input{
    width: 500px;
}
>>> .el-input--suffix{
    width: 380px !important;
}
.policy-box-input{
    width: 380px !important;
}
.box{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin: 0 0 0 40px;
}
.policy-box{
    width: 500px;
    margin: 10px 0 20px 10px;
    border: 1px solid #EDEDED;
    padding: 20px 0;
    border-radius: 6px;
}
.black-span{
    display: inline-block;
    width: 30px;
}
.submit-btn{
    margin: 30px 0;
}
</style>
